import { render, staticRenderFns } from "./attestation.vue?vue&type=template&id=acaef994&scoped=true"
import script from "./attestation.vue?vue&type=script&lang=js"
export * from "./attestation.vue?vue&type=script&lang=js"
import style0 from "./attestation.vue?vue&type=style&index=0&id=acaef994&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acaef994",
  null
  
)

export default component.exports